/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { ListEditsVideoEditorEditsQueryResponse, ListEditsVideoEditorEditsQueryParams } from "../models/ListEditsVideoEditorEdits";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listEditsVideoEditorEdits } from "../axios/listEditsVideoEditorEdits";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listEditsVideoEditorEditsQueryKey = (params: ListEditsVideoEditorEditsQueryParams) => ["web-app-bff-api", { url: '/video-editor/edits' }, ...(params ? [params] : [])] as const

export type ListEditsVideoEditorEditsQueryKey = ReturnType<typeof listEditsVideoEditorEditsQueryKey>

export function listEditsVideoEditorEditsQueryOptions(params: ListEditsVideoEditorEditsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listEditsVideoEditorEditsQueryKey(params)
        return queryOptions<ListEditsVideoEditorEditsQueryResponse, ResponseErrorConfig<Error>, ListEditsVideoEditorEditsQueryResponse, typeof queryKey>({
         enabled: !!(params),
         queryKey,
         queryFn: async ({ signal }) => {
            return listEditsVideoEditorEdits(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List edits for the client scoped to a fragment; each item includes creator, published platforms, and rendered video URL when a completed render exists
 * {@link /video-editor/edits}
 */
export function useListEditsVideoEditorEdits<TData = ListEditsVideoEditorEditsQueryResponse, TQueryData = ListEditsVideoEditorEditsQueryResponse, TQueryKey extends QueryKey = ListEditsVideoEditorEditsQueryKey>(params: ListEditsVideoEditorEditsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListEditsVideoEditorEditsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? listEditsVideoEditorEditsQueryKey(params)
         

         const query = useQuery({
          ...listEditsVideoEditorEditsQueryOptions(params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}